<input type="checkbox" [id]="id" [checked]="checked" [disabled]="disabled" (change)="toggle()" (focusin)="focusin()" (focusout)="focusout()"/>
<span style="{{ 'transform:scale(' + scale + ')'}}" class="a3l-ui-checkbox__indicator">
  <a3l-ui-icon icon="check"></a3l-ui-icon>
</span>
<label [attr.for]="id"></label>
<ng-content></ng-content>
